export type RowType = 'predefined' | 'collection' | 'category' | 'channel';

export interface Option {
    value: string;
    label: string;
    isDisabled?: boolean;
}

export const ROW_TYPE_API: Record<Exclude<RowType, 'predefined'>, number> = {
    channel: 0,
    collection: 1,
    category: 2
};

export const PREDEFINED_ROWS: { id: string; label: string; key: string; description: string }[] = [
    { id: '1', label: 'Trending Now', key: 'trendingNow', description: 'Content that is trending right now.' },
    { id: '2', label: 'Most Popular', key: 'mostPopular', description: 'Your most watched content.' },
    { id: '3', label: 'My List', key: 'myList', description: "Content the member saved to their list." },
    { id: '4', label: 'Recently Added', key: 'recentlyAdded', description: 'The newest content in your library.' },
    { id: '5', label: 'Featured Categories', key: 'categories', description: 'Highlighted categories.' },
    { id: '6', label: 'Channels', key: 'channels', description: 'All of your channels.' },
    { id: '7', label: 'Courses', key: 'courses', description: 'Your courses.' },
    { id: '8', label: 'Collections', key: 'collection', description: 'All of your collections.' },
    { id: '10', label: 'Ad Banner 2', key: 'adBanner2', description: 'Second ad banner placement.' },
    { id: '11', label: 'All Categories', key: 'allCategories', description: 'Every category in one row.' }
];

export const notPlaceholder = (i: any) => i.value !== '00000000-0000-0000-0000-000000000000';

export const SORT_OPTIONS: Option[] = [
    { value: 'newest', label: 'Newest first' },
    { value: 'oldest', label: 'Oldest first' },
    { value: 'title', label: 'Title (A-Z)' },
    { value: 'popular', label: 'Most popular' }
];

export const TYPE_META: Record<RowType, { label: string; icon: string; hint: string }> = {
    predefined: { label: 'Pre-defined Row', icon: 'fa-list', hint: 'Use one of our standard content rows.' },
    collection: { label: 'Collection', icon: 'fa-folder', hint: 'Show content from a specific collection.' },
    category: { label: 'Category', icon: 'fa-tag', hint: 'Show content from a specific category.' },
    channel: { label: 'Channel', icon: 'fa-play-circle', hint: 'Show all content from a channel.' }
};

export const PREDEFINED_IDS = PREDEFINED_ROWS.map((p) => p.id);

export const isPredefinedRow = (item: any) =>
    PREDEFINED_IDS.includes(String(item?.id)) || item?.spotlightRowType === null;

export const getRowType = (item: any): RowType => {
    if (isPredefinedRow(item)) return 'predefined';
    if (item?.spotlightRowType === 1) return 'collection';
    if (item?.spotlightRowType === 2) return 'category';
    return 'channel';
};

export const cleanRowName = (name: any = '') => name.replace(/\s*-\s*\([^)]*\)\s*$/, '');

export const ENABLE_ROW_OPTIONS = false;

export const SPOTLIGHT_ROW_MODAL_ID = 'spotlightRowModal';
